export default __webpack_public_path__ + "static/media/A6.52325697.png";